module.exports = __webpack_public_path__ + "static/media/3.9940eaf0.jpg";